
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-recommend-items/[id]/service",
      function () {
        return require("private-next-pages/funeral-recommend-items/[id]/service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-recommend-items/[id]/service"])
      });
    }
  